// Apple System Font & HIG Typography Scale
// ─────────────────────────────────────────────────────────────────────────────

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

// Apple System Font Stack
const FONT_PRIMARY = '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Inter, system-ui, sans-serif';

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontWeight: 700,
    lineHeight: 1.2,
    fontSize: pxToRem(34),
  },
  h2: {
    fontWeight: 700,
    lineHeight: 1.25,
    fontSize: pxToRem(28),
  },
  h3: {
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(22),
  },
  h4: {
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(20),
  },
  h5: {
    fontWeight: 600,
    lineHeight: 1.35,
    fontSize: pxToRem(17),
  },
  h6: {
    fontWeight: 600,
    lineHeight: 1.35,
    fontSize: pxToRem(15),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(17),
  },
  body2: {
    lineHeight: 1.5,
    fontSize: pxToRem(15),
  },
  caption: {
    lineHeight: 1.4,
    fontSize: pxToRem(13),
  },
  overline: {
    fontWeight: 600,
    lineHeight: 1.35,
    fontSize: pxToRem(11),
    letterSpacing: 0.8,
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 600,
    fontSize: pxToRem(15),
    lineHeight: 1.4,
    textTransform: 'none',
    letterSpacing: 0,
  },
};

export default typography;
